import { DataObjectMutationDtoSchema } from './DataObjectMutationDtoSchema';
import { DataObjectFormDataType, DataObjectMutationDtoType } from '../types';
import { DataObjectFormDataSchema } from './DataObjectFormDataSchema';
import { ConfidentialDataObjectSchema } from './formData/ConfidentialDataObjectSchema';
import { ConfidentialDataObjectType } from './formData/types';
import { DataObjectValidFormDataSchema } from './DataObjectValidFormDataSchema';
import { DataObjectValidFormDataType } from './types';

export class DataObjectSchema {
  static parseConfidentialDataObjects<Dto>(
    data: Dto[]
  ): ConfidentialDataObjectType[] {
    return ConfidentialDataObjectSchema.array().parse(data);
  }

  static parseFormData<Dto>(data: Dto): DataObjectFormDataType {
    return DataObjectFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<DataObjectValidFormDataType>
  >(validFormData: ValidFormData): DataObjectMutationDtoType {
    return DataObjectMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = DataObjectValidFormDataSchema;
}
